import axios from 'axios';
import { push } from 'connected-react-router';
import { IdentityUrl } from '../../config';
import { generateRandomCode } from '../../helpers/commons';
import { closeAdvancedSearch, closeMessageBox, openAdvancedSearch, openMessageBox } from '../main/actions'
import {
    CLEAN_FORM,
    DROP_APPLICATION,
    DROP_DISTRIBUIDOR,
    ERROR_USERS_LIST,
    RECEIVE_USERS_LIST,
    RECEIVE_USERS_LIST2,
    REQUEST_USERS_LIST,
    RESTART_STATE,
    SELECT_APPLICATION,
    SELECT_DISTRIBUIDOR,
    SET_APPLICATION_ROL,
    SET_ENTITY,
    SET_ERROR,
    SET_MASK,
    SET_ORDER,
    SET_PAGE,
    SET_PAGE_SIZE,
    SET_PASSWORD,
    SET_SELECTED_ROW,
    SET_STATE_FORM,
    UPDATE_FIELD_ENTITY,
    UPDATE_FIELD_FILTER,
    UPDATE_TABLE_COLUMN,
    ACTUALIZAR_SUB_MODAL
} from './types';

import { exportToSpreadsheet, cortarArreglo, Arol } from "../../../src/helpers/commons";


export const cleanForm = () => ({ type: CLEAN_FORM });

export const getUser = (usuarioId) => async (dispatch, getState) => {
    try {
        dispatch({ type: SET_MASK, loading: true });

        let url = `${IdentityUrl}/api/v1/usuarios/${usuarioId}`;
        let response = await axios.get(encodeURI(url));
        let payload = {
            ...response.data,
            aplicaciones: response.data.aplicaciones.map(item => { 
                return {
                    aplicacionClienteId: item.aplicacionClienteId,
                    nombre: item.nombre,
                    rol: item.rol || '',
                    rolId: item.rolId || ''
                }
            }),
            distribuidores: response.data.distribuidores.map(item => { 
                return {
                    distribuidorId: item.distribuidorId,
                    razonSocial: item.razonSocial
                }
            })
        };
        
        dispatch({ type: SET_ENTITY, payload });
    } catch (error) {
        if(error.response.status === 404) {
            dispatch(openMessageBox({ 
                button: 'ok', 
                icon: 'error', 
                message: 'No se encontro el registro solicitado.', 
                callback: () => { 
                    dispatch(closeMessageBox()); 
                    dispatch(push({
                        pathname: `/usuarios`,
                        search: getState().router.location.search,
                        hash: getState().router.location.hash
                    }));
                }
            }));
        }
        else {
            dispatch(openMessageBox({ 
                button: 'ok', 
                icon: 'error', 
                message: (error.response.data.eventLogId === 0 ? '' : `EventoId: ${error.response.data.eventLogId}. `) + error.response.data.message, 
                callback: () => dispatch(closeMessageBox())
            }));
        }
    } finally {
        dispatch({ type: SET_MASK, loading: false });
    }
};

export const onDropApplication  = (aplicacionClienteId) => ({ type: DROP_APPLICATION, aplicacionClienteId });

export const onDropDistribuidor  = (distribuidorId) => ({ type: DROP_DISTRIBUIDOR, distribuidorId });

export const onExport = () => async (dispatch, getState) => {
    try {
        if(getState().user.store.data.length === 0) {
            dispatch(openMessageBox({ 
                button: 'ok', 
                icon: 'warning', 
                message: 'No hay información para exportar.', 
                callback: () => dispatch(closeMessageBox())
            }));
            return;
        }

        dispatch({ type: SET_MASK, loading: true });

        let head = getState().user.table.columns;
        let json = getState().user.store.data1;


        exportToSpreadsheet(cortarArreglo(head,json) , "Usuarios");

  

    } catch (error) {
        dispatch(openMessageBox({ 
            button: 'ok', 
            icon: 'error', 
            message: (error.response.data.eventLogId === 0 ? '' : `EventoId: ${error.response.data.eventLogId}. `) + error.response.data.message, 
            callback: () => dispatch(closeMessageBox())
        }));
    } finally {
        dispatch({ type: SET_MASK, loading: false });
    }
};

export const onSearchApplicationClick = () => async (dispatch, getState) => {

    let fields = [
        { 'dataKey': 'nombre', 'label': 'Aplicación', 'type': 'string', 'width': 300 }
    ];

    try {

        dispatch(openAdvancedSearch({
            autoLoad: true,
            data: [],
            fields: fields,
            multiSelect: true,
            paginated: true,
            remote: true,
            multiSelect: true,
            title: 'Aplicaciones Cliente',
            getData: async (params) => {
                let url = `${IdentityUrl}/api/v1/usuarios/listAplicaciones`;
                let response = await axios.get(encodeURI(url), { params: params });
    
                const  aux = {
                    data: response.data  ,
                    pageSize: 50,
                    start: 0,
                    total: response.data.length
                }
                return aux;
            },
            callback: (btn, result) => {
                dispatch(closeAdvancedSearch());
                if(btn === 'yes') {

                    let aplicaciones = getState().user.entity.aplicaciones.map(item => ({ ...item}));

                    result.forEach(element => {
                        if(aplicaciones.filter(f => f.aplicacionClienteId === element.aplicacionClienteId).length === 0) {
                            aplicaciones.push({ aplicacionClienteId: element.aplicacionClienteId, nombre: element.nombre, rol: '', rolId: '' });
                        }
                    });

                    dispatch({ type: SELECT_APPLICATION, payload: aplicaciones });
                }
            }
        }));
    } catch (error) {
        if(error.response) {
            dispatch(openMessageBox({ 
                button: 'ok', 
                icon: 'error', 
                message: (error.response.data.eventLogId === 0 ? '' : `EventoId: ${error.response.data.eventLogId}. `) + error.response.data.message, 
                callback: () => dispatch(closeMessageBox())
            }));
        }
    }
};

export const onSearchApplicationRolClick = (aplicacionClienteId) => async (dispatch, getState) => {
    let fields = [
        { 'dataKey': 'nombreAn', 'label': 'Rol', 'search': true, 'type': 'string', 'width': 175 }
    ];

    let aplicacion = getState().user.entity.aplicaciones.find(item => item.aplicacionClienteId === aplicacionClienteId);

    dispatch(openAdvancedSearch({
        autoLoad: true,
        data: [],
        fields: fields,
        paginated: true,
        remote: true,
        title: aplicacion ? `Rol para ${aplicacion.nombre}` : 'Selección de Rol',
        getData: async (params) => {
            let url = `${IdentityUrl}/api/v1/usuarios/listRol`;
            let response = await axios.get(encodeURI(url), { params: params });

            const  aux = {
                data: response.data  ,
                pageSize: 50,
                start: 0,
                total: response.data.length
            }
            return aux;
        },
        callback: (btn, result) => {
            dispatch(closeAdvancedSearch());
            if(btn === 'yes') {
                dispatch({
                    type: SET_APPLICATION_ROL,
                    aplicacionClienteId,
                    rol: result[0].nombreAn,
                    rolId: result[0].rolId
                });
            }
        }
    }));
};

export const onSearchDistribuidorClick = () => async (dispatch, getState) => {
    let fields = [
        { 'dataKey': 'razonSocial', 'label': 'Agente', 'type': 'string', 'width': 225 }
    ];

    dispatch(openAdvancedSearch({
        autoLoad: true,
        data: [],
        fields: fields,
        paginated: true,
        remote: true,
        title: 'Selección de agente',
        getData: async (params) => {
            let url = `${IdentityUrl}/api/v1/distribuidores/porsesion`
            let response = await axios.get(encodeURI(url), { params: params });

            return response.data;
        },
        callback: (btn, result) => {
            dispatch(closeAdvancedSearch());
            if(btn === 'yes') {
                dispatch(onUpdateFieldEntity('distribuidorId', result[0].distribuidorId));
                dispatch(onUpdateFieldEntity('dDistribuidor', `${result[0].razonSocial}`));
            }
        }
    }));
};

export const onSearchDistribuidoresClick = () => async (dispatch, getState) => {

    let fields = [
        { 'dataKey': 'razonSocial', 'label': 'Agente', 'type': 'string', 'width': 220 }
    ];

    try {

        dispatch(openAdvancedSearch({
            autoLoad: true,
            data: [],
            fields: fields,
            multiSelect: true,
            paginated: true,
            remote: true,
            title: 'Aplicaciones Cliente',
            getData: async (params) => {
                let url = `${IdentityUrl}/api/v1/distribuidores/porsesion`
                let response = await axios.get(encodeURI(url), { params: params });
    
                return response.data;
            },
            callback: (btn, result) => {
                dispatch(closeAdvancedSearch());
                if(btn === 'yes') {

                    let distribuidores = getState().user.entity.distribuidores.map(item => ({ ...item}));

                    result.forEach(element => {
                        if(distribuidores.filter(f => f.distribuidorId === element.distribuidorId).length === 0) {
                            distribuidores.push({ distribuidorId: element.distribuidorId, razonSocial: element.razonSocial });
                        }
                    });

                    dispatch({ type: SELECT_DISTRIBUIDOR, payload: distribuidores });
                }
            }
        }));
    } catch (error) {
        if(error.response) {
            dispatch(openMessageBox({ 
                button: 'ok', 
                icon: 'error', 
                message: (error.response.data.eventLogId === 0 ? '' : `EventoId: ${error.response.data.eventLogId}. `) + error.response.data.message, 
                callback: () => dispatch(closeMessageBox())
            }));
        }
    }
};

export const onSearchUsuarioClick = () => async (dispatch, getState) => {
    let rol = '';

    switch (getState().user.entity.rol) {
        case 'Vendedor':
            rol = 'Supervisor';
            break;
        case 'Supervisor' :
            rol = 'Agente';
            break;
        case 'Agente'  :
            rol = 'Jefe zona';
            break;
        case 'Jefe zona':
            rol = 'Director general';
            break;
        case 'Planeación Colombia':
            rol = 'Director general';
                break;
        case 'Precios Colombia':
            rol = 'Planeación Colombia';
            break;
        case 'Asistente de Ventas':
            rol = 'Agente';
             break;
        case 'EC Vendedor':
                rol = 'EC Supervisor';
                break;
        case  'EC Supervisor':
                rol = 'EC Agente';
                break;
        case  'EC Agente' :
                rol = 'EC Jefe zona';
            break;
        case  'EC Jefe zona' :
                rol = 'EC Director general';
            break;
        case  'EC Consultor Ventas' :
            rol = 'EC Supervisor';
            break;
        default:
            break;
    }

    if(rol === '') {
        return;
    }

    let fields = [
        { 'dataKey': 'nombreUsuario', 'label': 'Usuario', 'type': 'string', 'width': 110 },
        { 'dataKey': 'nombre', 'label': 'Nombres', 'search': true, 'type': 'string', 'width': 175 },
        { 'dataKey': 'correo', 'label': 'Correo', 'type': 'string', 'width': 120 },
    ];

    dispatch(openAdvancedSearch({
        autoLoad: true,
        data: [],
        fields: fields,
        paginated: true,
        remote: true,
        title: 'Selección de usuario',
        getData: async (params) => {
            let url = `${IdentityUrl}/api/v1/usuarios/?rol=${rol}`
            let response = await axios.get(encodeURI(url), { params: params });
         
            return response.data;
        },
        callback: (btn, result) => {
            dispatch(closeAdvancedSearch());
            if(btn === 'yes') {
                dispatch(onUpdateFieldEntity('jerarquiaId', result[0].usuarioId));
                dispatch(onUpdateFieldEntity('dJerarquia', `${result[0].nombreUsuario} - ${result[0].nombre}`));
            }
        }
    }));
};

export const onUpdateFieldEntity = (key, value) => (dispatch) => {
    dispatch({ type: UPDATE_FIELD_ENTITY, key, value });

    if(key === 'nombre' || key === 'nombreUsuario' || key === 'correo' || key === 'distribuidor' || key === 'rol') {
        dispatch({ type: SET_ERROR, key, error: '' });
    }
};

export const onUpdateFieldFilter = (key, value) => ({ type: UPDATE_FIELD_FILTER, key, value  });

export const onUserList = () => async (dispatch, getState) => {
    if(getState().user.store.source) {
        getState().user.store.source.cancel();
    }

    let source = axios.CancelToken.source();
    let order = JSON.stringify([{
        property: getState().user.table.orderBy,
        direction: getState().user.table.order
    }]);
    dispatch({ type: REQUEST_USERS_LIST, source });
    
    try {
        let url = `${IdentityUrl}/api/v1/usuarios?`
        + `rolId=${getState().user.filters.rolId}`
        + `&nombreUsuario=${getState().user.filters.usuario}`
        + `&nombre=${getState().user.filters.nombre}`
        + `&sort=${order}&pageSize=${getState().user.store.pageSize}&start=${getState().user.store.start}`;
        let response = await axios.get(encodeURI(url), { cancelToken: source.token });
        let data = response.data;
        dispatch({ type: RECEIVE_USERS_LIST, total: data.total, payload: data.data });
        dispatch({ type: RECEIVE_USERS_LIST2, total: data.total, payload: data.data });

    } catch (error) {
        dispatch({ type: ERROR_USERS_LIST });
        if (!axios.isCancel(error)) {
            dispatch(openMessageBox({ 
                button: 'ok', 
                icon: 'error', 
                message: (error.response.data.eventLogId === 0 ? '' : `EventoId: ${error.response.data.eventLogId}. `) + error.response.data.message, 
                callback: () => dispatch(closeMessageBox())
            }));
        }
    }
};

export const restartState = () => ({ type: RESTART_STATE });

export const setFormState = (formState, id) => (dispatch, getState) => {
    switch (formState) {
        case 'edit':
            if(id && id !== getState().user.entity.usuarioId) {
                dispatch(getUser(id));
            }
            break;
        case 'new':
            dispatch(cleanForm());
            dispatch(setPassword(generateRandomCode(8)));
            break;
        case 'restart':
            if(id && id !== getState().user.entity.usuarioId) {
                dispatch(getUser(id));
            }
            dispatch(setPassword(generateRandomCode(8)));
            break;
        case 'search':
            dispatch(cleanForm());
            break;
        case 'view':
            if(id && id !== getState().user.entity.usuarioId) {
                dispatch(getUser(id));
            }
            break;
        default:
            break;
    }
    dispatch({ type: SET_STATE_FORM, formState });
}

export const setOrder = (order, orderBy) => ({ type: SET_ORDER, order, orderBy });

export const setPage = (page) => ({ type: SET_PAGE, page });

export const setPageSize = (pageSize) => ({ type: SET_PAGE_SIZE, pageSize });

export const setPassword = (password) => ({ type: SET_PASSWORD, password });

export const setSelectedRow = (selected) => ({ type: SET_SELECTED_ROW, selected});

export const btnDelete = () => (dispatch) => {
    dispatch(openMessageBox({
        button: 'yesno',
        icon: 'question',
        message: 'Se elimanara el registro permanentemente. ¿Desea continuar?',
        callback: btn => dispatch(onDelete(btn))
    }));
};

export const btnSave = () => (dispatch, getState) => {
    if(getState().user.entity.nombre === '') {
        dispatch({ type: SET_ERROR, key: 'nombre', error: 'Este campo es requerido' })
    }

    if(getState().user.entity.nombreUsuario === '') {
        dispatch({ type: SET_ERROR, key: 'nombreUsuario', error: 'Este campo es requerido' })
    }

    if(getState().user.entity.correo === '') {
        dispatch({ type: SET_ERROR, key: 'correo', error: 'Este campo es requerido' })
    }

    if(getState().user.entity.dDistribuidor === '') {
        dispatch({ type: SET_ERROR, key: 'distribuidor', error: 'Este campo es requerido' })
    }

    if(getState().user.errors.nombre !== '' || getState().user.errors.nombreUsuario !== '' || getState().user.errors.correo !== ''
        || getState().user.errors.distribuidor !== '') {
        return;
    }

    let aplicaciones = getState().user.entity.aplicaciones;
    let hayAplicacionSinRol = aplicaciones.some(item => !item.rolId);

    if(hayAplicacionSinRol) {
        dispatch(openMessageBox({
            button: 'ok',
            icon: 'warning',
            message: 'Debe completar todos los campos. Asigne un rol a todas las aplicaciones permitidas antes de guardar.',
            callback: () => dispatch(closeMessageBox())
        }));
        return;
    }

    dispatch(openMessageBox({
        button: 'yesno',
        icon: 'question',
        message: '¿Desea guardar la información?',
        callback: btn => {
            if(getState().user.entity.usuarioId === '') {
                dispatch(onSave(btn));
            }
            else {
                dispatch(onUpdate(btn));
            }

        }
    }));
};

export const btnSearch = () => (dispatch) => {
    dispatch(setPage(0));
    dispatch(onUserList());
};

export const onDelete = (btn) => async (dispatch, getState) => {
    dispatch(closeMessageBox());

    if(btn === 'yes') {
        try {
            dispatch({ type: SET_MASK, loading: true });

            let usuarioId = getState().user.entity.usuarioId;
            let url = `${IdentityUrl}/api/v1/usuarios/${usuarioId}`;
            await axios.delete(encodeURI(url));

            dispatch(openMessageBox({ 
                button: 'ok', 
                icon: 'info', 
                message: 'El registro se elimino correctamente.', 
                callback: () => { 
                    dispatch(closeMessageBox());
                    dispatch(push({
                        pathname: '/usuarios',
                        search: getState().router.location.search,
                        hash: getState().router.location.hash
                    }));
                    dispatch(onUserList());
                }
            }));
        } catch (error) {
            dispatch(openMessageBox({ 
                button: 'ok', 
                icon: 'error', 
                message: (error.response.data.eventLogId === 0 ? '' : `EventoId: ${error.response.data.eventLogId}. `) + error.response.data.message, 
                callback: () => dispatch(closeMessageBox())
            }));
        } finally {
            dispatch({ type: SET_MASK, loading: false });
        }
    }
};

export const onSave = (btn) => async (dispatch, getState) => {
    dispatch(closeMessageBox());

    if(btn === 'yes') {
        try {
            dispatch({ type: SET_MASK, loading: true });

            let aplicaciones = getState().user.entity.aplicaciones;
            let primeraAplicacionConRol = aplicaciones.find(item => item.rolId);

            let usuario = {
                ...getState().user.entity,
                rol: primeraAplicacionConRol ? primeraAplicacionConRol.rol : '',
                rolId: primeraAplicacionConRol ? primeraAplicacionConRol.rolId : '',
                aplicaciones: aplicaciones.map(item => {
                    return {
                        aplicacionClienteId: item.aplicacionClienteId,
                        rol: item.rol || null,
                        rolId: item.rolId || null
                    };
                }),
                distribuidores: getState().user.entity.distribuidores.map(item => {
                    return {
                        distribuidorId: item.distribuidorId
                    };
                })
            };

            let url = `${IdentityUrl}/api/v1/usuarios`;
            let response = await axios.post(url, usuario, {headers: {'Content-Type': 'application/json'}});
            let data = response.data;

            dispatch(openMessageBox({ 
                button: 'ok', 
                icon: 'info', 
                message: 'Registro realizado con exito.', 
                callback: () => { 
                    dispatch(closeMessageBox()); 
                    dispatch(push({
                        pathname: `/usuarios/${data}`,
                        search: getState().router.location.search,
                        hash: getState().router.location.hash
                    }));
                }
            }));
        } catch (error) {
            dispatch(openMessageBox({ 
                button: 'ok', 
                icon: 'error', 
                message: (error.response.data.eventLogId === 0 ? '' : `EventoId: ${error.response.data.eventLogId}. `) + error.response.data.message, 
                callback: () => dispatch(closeMessageBox())
            }));
        } finally {
            dispatch({ type: SET_MASK, loading: false });
        }
    }
};

export const onUpdate = (btn) => async (dispatch, getState) => {
    dispatch(closeMessageBox());

    if(btn === 'yes') {
        try {
            dispatch({ type: SET_MASK, loading: true });

            let entity = getState().user.entity;
            let primeraAplicacionConRol = entity.aplicaciones.find(item => item.rolId);

            let usuario = {
                ...entity,
                rol: entity.rol || (primeraAplicacionConRol ? primeraAplicacionConRol.rol : ''),
                rolId: entity.rolId || (primeraAplicacionConRol ? primeraAplicacionConRol.rolId : ''),
                aplicaciones: entity.aplicaciones.map(item => {
                    return {
                        aplicacionClienteId: item.aplicacionClienteId,
                        rol: item.rol || null,
                        rolId: item.rolId || null
                    };
                }),
                distribuidores: entity.distribuidores.map(item => {
                    return {
                        distribuidorId: item.distribuidorId
                    };
                })
            };

            if(entity.clave !== '') {
                usuario.ReiniciarClave = true;
            }

            let url = `${IdentityUrl}/api/v1/usuarios`;
            let response = await axios.put(url, usuario, {headers: {'Content-Type': 'application/json'}});
            let data = response.data;
            console.log(data,'que traes ')

            dispatch(openMessageBox({ 
                button: 'ok', 
                icon: 'info', 
                message: 'Modificación realizado con exito.', 
                callback: () => { 
                    dispatch(closeMessageBox());
                    dispatch(push({
                        pathname: `/usuarios/${data}`,
                        search: getState().router.location.search,
                        hash: getState().router.location.hash
                    }));
                    dispatch(getUser(data));
                }
            }));
        } catch (error) {
            if(error.response.status === 404) {
                dispatch(openMessageBox({ 
                    button: 'ok', 
                    icon: 'error', 
                    message: 'No se encontro el registro solicitado.', 
                    callback: () => { 
                        dispatch(closeMessageBox()); 
                        dispatch(push({
                            pathname: `/usuarios`,
                            search: getState().router.location.search,
                            hash: getState().router.location.hash
                        }));
                    }
                }));
            }
            else {
                dispatch(openMessageBox({ 
                    button: 'ok', 
                    icon: 'error', 
                    message: (error.response.data.eventLogId === 0 ? '' : `EventoId: ${error.response.data.eventLogId}. `) + error.response.data.message, 
                    callback: () => dispatch(closeMessageBox())
                }));
            }
        } finally {
            dispatch({ type: SET_MASK, loading: false });
        }
    }
};

export const onUpdateColumn = (column) => (dispatch, getState) => {
    let columns = getState().user.table.columns.map(item => {
        if(item.dataKey !== column.dataKey) {
            return item;
        }

        return {
            ...item,
            width: column.width
        }
    });

    dispatch({ type: UPDATE_TABLE_COLUMN, columns });
};

export const actualizaSubModal = (detalle) => (dispatch, getState) =>{
    dispatch ({ type: ACTUALIZAR_SUB_MODAL, payload:detalle })
  };

export const onRol = () => async (dispatch) => {
    let fields = [
        { dataKey: 'nombre', label: 'Rol', type: 'string', width: 175 }
    ];

    dispatch(openAdvancedSearch({
        autoLoad: true,
        data: [],
        fields: fields,
        paginated: true,
        remote: true,
        title: "Selección de Rol",
        getData: async (params) => {
            let url = `${IdentityUrl}/api/v1/usuarios/listRol`;
            let response = await axios.get(encodeURI(url), { params: params });
            const  aux = {
                data: response.data  ,
                pageSize: 50,
                start: 0,
                total: response.data.length
            }
            return aux;
        },
        callback: (btn, result) => {
            dispatch(closeAdvancedSearch());
            if(btn === 'yes') {
                dispatch(onUpdateFieldFilter('rol', `${result[0].nombre}`));
                dispatch(onUpdateFieldFilter('rolId', `${result[0].rolId}`));
            }
        },
    }));
};